import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField } from "@mui/material";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import moment from "moment";

const dateFormat = "YYYY-MM-DD HH:mm:ss";

export default function ImitateLoginDialog({ open, onClose, onConfirm, loginDate, handleLoginDateChange }) {
	return (
		<Dialog open={open} onClose={onClose} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
			<DialogTitle id="alert-dialog-title">Imitate Login</DialogTitle>
			<DialogContent>
				<Grid container>
					<Grid item xs={12} sx={{ m: 0, p: 1 }}>
						<LocalizationProvider dateAdapter={AdapterMoment}>
							<DateTimePicker
								label="Login Date"
								value={moment(loginDate.date, dateFormat)}
								onChange={(value) => handleLoginDateChange(value, "date")}
								renderInput={(params) => <TextField {...params} fullWidth />}
							/>
						</LocalizationProvider>
					</Grid>
				</Grid>
			</DialogContent>
			<DialogActions>
				<Button onClick={onClose}>Cancel</Button>
				<Button onClick={onConfirm} autoFocus>
					Update
				</Button>
			</DialogActions>
		</Dialog>
	);
}
